import { ChangePartner } from './ChangePartner';

export class ChangePartnerLinkText extends ChangePartner {
  type: string = 'Partner.ChangeLinkText';
}
